<form [formGroup]="form" class="contacts-form">
  <div class="checkout-section-title">
    <h2 class="m-0 text-b3-m-700 text-md-b1-s-700 text-lg-b1-m-700 color-black">контакты</h2>
    <sd-checkout-validation-error [errorKeys]="['CONTACTS_REQUIRED']"></sd-checkout-validation-error>
  </div>

  <sd-input label="номер телефона">
    <input #inputRef formControlName="phone" type="tel" sdPhoneMaskFix sdPhoneAuthorizedUser />
  </sd-input>

  <sd-input label="email">
    <input #inputRef formControlName="email" type="text" />
  </sd-input>

  <sd-textarea label="комментарий к заказу">
    <textarea formControlName="comment" maxlength="500"></textarea>
  </sd-textarea>

  @if (isDesktopLgUp()) {
    <sd-submit-order></sd-submit-order>
  }
</form>
